module.exports = __webpack_public_path__ + "static/media/india-map.c6a2901d.png";